import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import styled from "styled-components";
import { Link } from "gatsby";

const query = graphql`
  {
    allMdx {
      distinct(field: frontmatter___category)
    }
  }
`;

const PostButtons = () => {
  const {
    allMdx: { distinct: categories },
  } = useStaticQuery(query);

  return (
    <ButtonsStyled>
      {categories.map((category, index) => {
        return (
          <ButtonStyled key={index} to={`/${category}`}>
            {category}
          </ButtonStyled>
        );
      })}
    </ButtonsStyled>
  );
};

const ButtonStyled = styled(Link)`
  outline: none;
  border: none;
  background-color: var(--clr-primary-5);
  padding: 0.4rem 2rem;
  font-size: inherit;
  color: var(--clr-primary-1);
  cursor: pointer;
  transition: all 0.4s ease-in-out;
  margin-bottom: 0.6rem;
  text-transform: capitalize;
  &:active,
  &:focus {
    background-color: var(--clr-primary-7);
  }
  &:hover {
    background-color: var(--clr-primary-7);
  }

  &:not(:last-child) {
    margin-right: 0.6rem;
  }
`;

const ButtonsStyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  width: 70%;
  margin: 2.4rem auto;
`;

export default PostButtons;
